import styles from './M38MultiCategoryLinksModule.module.scss';
import classNames from 'classnames';
import { M38SubmoduleCategoryLinkSection, M38SubmoduleCategoryLinkSectionProps } from 'ui/components';
import { SurfaceSection } from 'ui/components/4-habitats/SurfaceSection/SurfaceSection';

export interface M38MultiCategoryLinksModuleProps {
	gridColumn?: 'Single' | 'Double' | 'Triple';
	categoryLinks?: M38SubmoduleCategoryLinkSectionProps[];
	columns?: number;
	backgroundColorKey?: string | null;
	anchor?: string;
}

export const M38MultiCategoryLinksModule: React.FC<M38MultiCategoryLinksModuleProps> = ({
	gridColumn,
	categoryLinks,
	columns,
	backgroundColorKey,
	anchor,
}) => {
	const columnCount = gridColumn === 'Single' ? 1 : gridColumn === 'Triple' ? 3 : gridColumn === 'Double' ? 2 : columns;

	return (
		<SurfaceSection {...(anchor ? { id: anchor } : {})} surfaceKey={backgroundColorKey} withContainer containerWidth="StandardWeb">
			<section
				className={classNames(
					styles.M38MultiCategoryLinksModule,
					columnCount === 3 ? styles.isCols3 : columnCount === 2 ? styles.isCols2 : styles.isCols1,
				)}
			>
				<div className={styles.M38MultiCategoryLinksModule_grid}>
					{categoryLinks?.map((categoryLink, idx) => (
						<article key={idx} className={styles.M38MultiCategoryLinksModule_card}>
							<M38SubmoduleCategoryLinkSection {...categoryLink} />
						</article>
					))}
				</div>
			</section>
		</SurfaceSection>
	);
};
